import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private oauthService: OAuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Récupérer le token
    const token = this.oauthService.getAccessToken();

    // Si pas de token, laisser passer la requête sans modification
    if (!token) {
      console.log('🌐 [AuthInterceptor] Pas de token, requête sans Authorization:', req.url);
      return next.handle(req);
    }



    // ⚡ IMPORTANT: Ne pas ajouter le token aux requêtes vers le serveur OAuth
    // Sinon, ça peut causer des problèmes CORS
    const isOAuthRequest = req.url.includes('/oauth2/') ||
      req.url.includes('/.well-known/') ||
      req.url.includes(this.oauthService.issuer || '');

    if (isOAuthRequest) {
      console.log('🔐 [AuthInterceptor] Requête OAuth, pas de token ajouté:', req.url);
      return next.handle(req);
    }

    // ⚡ FILTRAGE: Ajouter le token uniquement aux requêtes vers votre API
    const isApiRequest = req.url.includes('/api/') ||
      req.url.startsWith('http://bo.ankata.local/api/') ||
      req.url.startsWith('http://identity.ankata.local/api/');

    // if (!isApiRequest) {
    //   console.log('🌐 [AuthInterceptor] Requête externe, pas de token ajouté:', req.url);
    //   return next.handle(req);
    // }

    // Cloner la requête et ajouter le header Authorization
    const clonedReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`).set('X-Device', 'Web')
    });

    console.log('✅ [AuthInterceptor] Token ajouté à la requête:', req.url);
    console.log('🎫 [AuthInterceptor] Token:', token.substring(0, 20) + '...');

    return next.handle(clonedReq);
  }
}
